export default defineComponent({
  props: {},
  setup: function setup() {
    return {};
  }
});